"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HikansabumonChiefHyokaResult = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _ActionMessage = _interopRequireDefault(require("01_core/components/materials/ActionMessage"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KansaTgtJigyoBasicInfo = _interopRequireDefault(require("../../common/components/materials/KansaTgtJigyoBasicInfo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 被監査部門責任者評価登録結果画面
 */
const StyledReturnButton = (0, _styles.styled)(_CButton.default)({
  margin: '0 8px 0 auto'
});
const StyledNewLineTypography = (0, _styles.styled)(_material.Typography)(_ref => {
  let {
    theme
  } = _ref;
  return {
    whiteSpace: 'pre-line',
    fontSize: theme.typography.body2.fontSize
  };
});
class HikansabumonChiefHyokaResult extends _react.default.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      entries,
      intl,
      kansaTgtJigyoBasicInfo,
      mailErrMsg,
      btnProps
    } = this.props;

    // 戻るボタン
    const returnButton = /*#__PURE__*/_react.default.createElement(StyledReturnButton, {
      onClick: btnProps.onClick(true),
      autoWidth: true,
      negative: true
    }, btnProps.label);
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_HIKANSA_HYOKA_REGISTER_RESULT
      })
    }, /*#__PURE__*/_react.default.createElement(_material.CardActions, {
      sx: {
        justifyContent: 'flex-start'
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      sx: {
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 9
      },
      sx: {
        textAlign: 'left'
      }
    }, /*#__PURE__*/_react.default.createElement(_ActionMessage.default, {
      action: "register",
      supplement: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, mailErrMsg))
    })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 3
      },
      sx: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, returnButton))), /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_KansaTgtJigyoBasicInfo.default, {
      data: kansaTgtJigyoBasicInfo
    }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KINYU_DATE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2"
    }, entries.kinyuDate)), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KINYUSHA_NM
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2"
    }, entries.kinyushaNm)), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_COMMENT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(StyledNewLineTypography, null, entries.hikansabumonChiefComment))))), /*#__PURE__*/_react.default.createElement(_material.CardActions, null, returnButton));
  }
}
exports.HikansabumonChiefHyokaResult = HikansabumonChiefHyokaResult;
const mapStateToProps = state => {
  return {
    entries: state.kansaResult.entries,
    userInfo: state.kansaResult.userInfo,
    kansaTgtJigyoBasicInfo: state.kansaResult.kansaTgtJigyoBasicInfo,
    mailErrMsg: state.kansaResult.mailErrMsg
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(HikansabumonChiefHyokaResult)));